/* global axios */
import ApiClient from '../ApiClient';

// V1 Admin Intelligence Bridge (Part 7) — thin client for the existing
// Nexceo::Ai::WorkforceAnalyticsService (M26), exposed via
// WorkforceAnalyticsController. No aggregation logic here.
class NexceoWorkforceAnalyticsAPI extends ApiClient {
  constructor() {
    super('nexceo/workforce_analytics', { accountScoped: true });
  }

  get(since = null) {
    return axios.get(this.url, { params: since ? { since } : {} });
  }
}

export default new NexceoWorkforceAnalyticsAPI();
